import { AccountType, MouTemplateType } from 'eve-account-client';
import {
  AccessMethodFormData,
  AccessMethodType,
} from '../../../components/Enrollment/AccessMethod/AccessMethodFormData';
import { EnrollmentType } from '../EnrollmentData';

const accountInfoMap = new Map<AccessMethodType, AccessMethodFormData>([
  [AccessMethodType.EMPLOYER, { type: AccountType.EMPLOYER, webServiceAccess: false }],
  [AccessMethodType.AGENCY, { type: AccountType.AGENCY, webServiceAccess: false }],
  [AccessMethodType.EMPLOYER_WS, { type: AccountType.EMPLOYER, webServiceAccess: true }],
  [AccessMethodType.AGENCY_WS, { type: AccountType.AGENCY, webServiceAccess: true }],
  [AccessMethodType.CORPORATE, { type: AccountType.CORPORATE, webServiceAccess: false }],

  [AccessMethodType.CHILD, { type: AccountType.CHILD, webServiceAccess: false }],
  [AccessMethodType.CHILD_WS, { type: AccountType.CHILD, webServiceAccess: true }],
]);

const mouTemplateTypeMap = new Map<AccessMethodType, MouTemplateType>([
  [AccessMethodType.EMPLOYER, MouTemplateType.EMPLOYER],
  [AccessMethodType.AGENCY, MouTemplateType.EMPLOYERAGENT],
  [AccessMethodType.EMPLOYER_WS, MouTemplateType.EMPLOYERWEBSERVICE],
  [AccessMethodType.AGENCY_WS, MouTemplateType.EMPLOYERAGENTWEBSERVICE],

  [AccessMethodType.CHILD, MouTemplateType.EMPLOYER],
  [AccessMethodType.CHILD_WS, MouTemplateType.EMPLOYERWEBSERVICE],
]);

export const getFormDataByType = (accessMethod: AccessMethodType): AccessMethodFormData | undefined => {
  return accountInfoMap.get(accessMethod);
};

export const getTypeByFormData = (
  accessMethodFormData: AccessMethodFormData | undefined,
): AccessMethodType | undefined =>
  Array.from(accountInfoMap).find(
    ([, { type, webServiceAccess }]) =>
      type === accessMethodFormData?.type && webServiceAccess === accessMethodFormData.webServiceAccess,
  )?.[0];

export const getMouTemplateTypeByFormData = (
  accessMethodFormData: AccessMethodFormData | undefined,
): MouTemplateType | undefined => {
  const accessMethod = getTypeByFormData(accessMethodFormData);
  return accessMethod && mouTemplateTypeMap.get(accessMethod);
};

export function getEmployerAccessMethod(
  enrollmentType: EnrollmentType,
): AccessMethodType.EMPLOYER | AccessMethodType.CHILD {
  switch (enrollmentType) {
    case EnrollmentType.CHILD:
      return AccessMethodType.CHILD;
    default:
    case EnrollmentType.INITIAL:
      return AccessMethodType.EMPLOYER;
  }
}

export function getEmployerWSAccessMethod(
  enrollmentType: EnrollmentType,
): AccessMethodType.EMPLOYER_WS | AccessMethodType.CHILD_WS {
  switch (enrollmentType) {
    case EnrollmentType.CHILD:
      return AccessMethodType.CHILD_WS;
    default:
    case EnrollmentType.INITIAL:
      return AccessMethodType.EMPLOYER_WS;
  }
}
